import { render, staticRenderFns } from "./StepFrame.vue?vue&type=template&id=25432f56&lang=pug&"
import script from "./StepFrame.vue?vue&type=script&lang=js&"
export * from "./StepFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports